import React from 'react';

function Navbar({ activeTab, onNavigate }) {
  return (
    <div className="navbar1_component">
      <div className="navbar1_container">
        <div
          className="navbar1_logo-link"
          onClick={() => onNavigate('logicapps')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="https://cdn.prod.website-files.com/67e26aef79a7047719ea9db8/67e28ceff1544e195a3a2269_astena.svg"
            alt="Astena Logo"
            className="navbar1_logo"
          />
        </div>
        <nav className="navbar1_menu">
          <span
            className={`navbar1_link ${activeTab === 'logicapps' ? 'active' : ''}`}
            onClick={() => onNavigate('logicapps')}
          >
            Logic Apps
          </span>
          <span
            className={`navbar1_link ${activeTab === 'apidocs' ? 'active' : ''}`}
            onClick={() => onNavigate('apidocs')}
          >
            API Docs
          </span>
          <span
            className={`navbar1_link ${activeTab === 'setup' ? 'active' : ''}`}
            onClick={() => onNavigate('setup')}
          >
            Setup
          </span>
          <span
            className={`navbar1_link ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => onNavigate('about')}
          >
            About
          </span>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
